import React, { useEffect, useState } from "react";
import {
  isPushSupported,
  enablePushNotifications,
  disablePushNotifications,
  getPushSubscription,
} from "../lib/pushClient";

export default function PushToggle() {
  const [supported] = useState(isPushSupported());
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [perm, setPerm] = useState(typeof Notification !== "undefined" ? Notification.permission : "default");

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!supported) { setLoading(false); return; }
      try {
        const sub = await getPushSubscription();
        if (mounted) setEnabled(!!sub);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [supported]);

  const onToggle = async () => {
    setError("");
    setLoading(true);
    try {
      if (enabled) {
        await disablePushNotifications();
        setEnabled(false);
      } else {
        await enablePushNotifications();
        setEnabled(true);
      }
      if (typeof Notification !== "undefined") setPerm(Notification.permission);
    } catch (e) {
      setError(e.message || "No se pudo cambiar el estado de las notificaciones.");
    } finally {
      setLoading(false);
    }
  };

  if (!supported) {
    return (
      <div className="flex items-center gap-3 px-5 py-4 bg-slate-50" data-testid="push-unsupported">
        <span className="w-10 h-10 rounded-full bg-slate-200 text-slate-500 flex items-center justify-center">
          <i className="fa-regular fa-bell-slash"></i>
        </span>
        <div className="flex-1">
          <div className="font-semibold text-slate-700">Notificaciones</div>
          <div className="text-xs text-slate-500">Tu navegador no admite notificaciones push.</div>
        </div>
      </div>
    );
  }

  const denied = perm === "denied";

  return (
    <div className="px-5 py-4 flex items-center gap-3" data-testid="push-toggle-row">
      <span className={`w-10 h-10 rounded-full flex items-center justify-center ${enabled ? "bg-green-100 text-green-600" : "bg-blue-100 text-blue-600"}`}>
        <i className={`fa-regular ${enabled ? "fa-bell" : "fa-bell-slash"}`}></i>
      </span>
      <div className="flex-1">
        <div className="font-semibold text-slate-900">Notificaciones push</div>
        <div className="text-xs text-slate-500">
          {denied ? "Permiso bloqueado. Habilítalas desde los ajustes del navegador."
            : enabled ? "Recibirás avisos cuando alguien te escriba." : "Activa avisos en este dispositivo cuando recibas mensajes."}
        </div>
        {error && <div className="text-xs text-red-600 mt-1" data-testid="push-error">{error}</div>}
      </div>
      <button
        type="button"
        onClick={onToggle}
        disabled={loading || denied}
        data-testid="push-toggle-btn"
        aria-pressed={enabled}
        className={`relative inline-flex h-7 w-12 flex-shrink-0 rounded-full transition-colors ${enabled ? "bg-blue-600" : "bg-slate-300"} ${denied || loading ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        <span className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition ${enabled ? "translate-x-5" : "translate-x-0.5"} mt-0.5`}></span>
      </button>
    </div>
  );
}
